export type PlayerRankSite = "opgg" | "ugg" | "dpmlol";

export interface PlayerRankLink {
  id: PlayerRankSite;
  label: string;
  url: string;
  iconUrl: string;
}

const normalizeRiotSlug = (displayName: string, tagLine: string): string => {
  const name = displayName.trim();
  const tag = tagLine.trim();
  if (!name || !tag) {
    return "";
  }
  return `${name}-${tag}`;
};

export const getPlayerOpggUrl = (displayName: string, tagLine: string): string => {
  const slug = normalizeRiotSlug(displayName, tagLine);
  if (!slug) {
    return "";
  }
  return `https://op.gg/fi/lol/summoners/euw/${encodeURIComponent(slug)}`;
};

export const getPlayerUggUrl = (displayName: string, tagLine: string): string => {
  const slug = normalizeRiotSlug(displayName, tagLine);
  if (!slug) {
    return "";
  }
  return `https://u.gg/lol/profile/euw1/${encodeURIComponent(slug)}/overview`;
};

export const getPlayerDpmLolUrl = (displayName: string, tagLine: string): string => {
  const slug = normalizeRiotSlug(displayName, tagLine);
  if (!slug) {
    return "";
  }
  return `https://dpm.lol/${encodeURIComponent(slug)}`;
};

const RANK_SITE_ICONS: Record<PlayerRankSite, string> = {
  opgg: "/icons/rank-sites/opgg.ico",
  ugg: "/icons/rank-sites/ugg.ico",
  dpmlol: "/icons/rank-sites/dpmlol.png",
};

export const getPlayerRankLinks = (displayName: string, tagLine: string): PlayerRankLink[] => {
  const links: PlayerRankLink[] = [
    {
      id: "opgg",
      label: "OP.GG",
      url: getPlayerOpggUrl(displayName, tagLine),
      iconUrl: RANK_SITE_ICONS.opgg,
    },
    {
      id: "ugg",
      label: "U.GG",
      url: getPlayerUggUrl(displayName, tagLine),
      iconUrl: RANK_SITE_ICONS.ugg,
    },
    {
      id: "dpmlol",
      label: "DPM.LOL",
      url: getPlayerDpmLolUrl(displayName, tagLine),
      iconUrl: RANK_SITE_ICONS.dpmlol,
    },
  ];

  return links.filter((link) => link.url);
};
